import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";
import UserRoles from "constants/UserRoles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import classNames from "classnames";
import {Button, ButtonGroup} from 'reactstrap';

const breadcrumbsStatic = [{
	name: 'Scores',
	url: '/scores',
	icon: 'users',
}];

class Scores extends Framework.Components.View {
	constructor(props) {
		super(props, 'phonelogsamount-3');
		this.state.isDaily = false;
	}

	render() {
		let {history, roles} = this.props;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: 'High Scores',
				url: `/scores/highs`,
				icon: 'users',
			}
		]);

		return (
			<div className={'container-fluid'}>

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}>
					<div className={'flex-column'} style={{display: 'flex'}}>
						<ButtonGroup size={"md"}>
							<Button
								onClick={() => {
									this.setState({isDaily: true, key: Math.random})
								}}
								outline={this.state.isDaily === false}
								active={this.state.isDaily === true}
							>
								Daily
							</Button>
							<Button
								onClick={() => {
									this.setState({isDaily: false, key: Math.random()})
								}}
								outline={this.state.isDaily === true}
								active={this.state.isDaily === false}
							>
								Hourly
							</Button>
						</ButtonGroup>
					</div>
				</Framework.Components.PageBar>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Phone Logs Amount" value="phonelogsamount-3"/>
					<Tab label="Book Types Count" value="bookcount-4"/>
					<Tab label="Phone Logs Notes" value="phonelogsnotes-5"/>
					<Tab label="Calendar Notes" value="calendarnotes-6"/>
					<Tab label="Time Between Events" value="tbe-7"/>
				</Tabs>

				<div className={classNames({'hidden': this.state.tab !== 'phonelogsamount-3'})}>
					<Collections.HighScores
						key={this.state.isDaily}
						id={3}
						history={this.props.history} isDaily={this.state.isDaily}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={this.props.roles.includes(UserRoles.Admin)}
					/>
				</div>

				<div className={classNames({'hidden': this.state.tab !== 'bookcount-4'})}>
					<Collections.HighScores
						key={this.state.isDaily}
						id={4}
						history={this.props.history} isDaily={this.state.isDaily}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={this.props.roles.includes(UserRoles.Admin)}
					/>
				</div>
				<div className={classNames({'hidden': this.state.tab !== 'phonelogsnotes-5'})}>
					<Collections.HighScores
						key={this.state.isDaily}
						id={5}
						history={this.props.history} isDaily={this.state.isDaily}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={this.props.roles.includes(UserRoles.Admin)}
					/>
				</div>
				<div className={classNames({'hidden': this.state.tab !== 'calendarnotes-6'})}>
					<Collections.HighScores
						key={this.state.isDaily}
						id={6}
						history={this.props.history} isDaily={this.state.isDaily}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={this.props.roles.includes(UserRoles.Admin)}
					/>
				</div>
				<div className={classNames({'hidden': this.state.tab !== 'tbe-7'})}>
					<Collections.HighScores
						key={this.state.isDaily}
						id={7}
						history={this.props.history} isDaily={this.state.isDaily}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={this.props.roles.includes(UserRoles.Admin)}
					/>
				</div>
			</div>

		)
	}
}

export default Framework.Components.withRootState(Scores);